// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1DFZe","actions":"GroupTable_actions__YpNPk","deleteModalFooter":"GroupTable_deleteModalFooter__fcnDB"};